import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import IeSquareFilledSvg from "@ant-design/icons-svg/es/asn/IeSquareFilled";
import AntdIcon from "../components/AntdIcon";
var IeSquareFilled = function IeSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: IeSquareFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  IeSquareFilled.displayName = 'IeSquareFilled';
}
export default /*#__PURE__*/React.forwardRef(IeSquareFilled);